import { faMap } from '@fortawesome/pro-solid-svg-icons';
import { useMemo } from 'react';
import { ButtonStyle } from '~/_shared/baseComponents/buttons/button/button.types';
import { useFileExportStatusItems } from '~/_shared/components/topUnderbar/statusItem/useFileExportStatusItems.hook';
import { renderBoundaryWMSOptimizedTerritoryItem } from '~/_shared/components/topUnderbar/WMSOptimizedTerritoriesProgress/topUnderbarWMSOptimizedTerritories.component';
import { type Announcement } from '~/_shared/types/announcement.types';
import { noop } from '~/_shared/utils/function.helpers';
import { useTranslation } from '~/_shared/utils/hooks';
import { BoundaryCreateWMSOptimizedStatus } from '~/store/frontendState/mapTools/boundary/boundaryCreateWMSOptimized/boundaryCreateWMSOptimized.state';
import { renderAnnouncement } from '../announcements/topUnderbarAnnouncement.component';
import { renderConfirmation } from '../confirmations/topUnderbarConfirmation.component';
import { renderGeocodingState } from '../geocodingProgress/topUnderbarGeocoding.component';
import { renderSearchEntries } from '../searchEntries/topUnderbarSearchEntries.component';
import { useExportImageStatusItems } from '../statusItem/useExportImageStatusItems.hook';
import { useMapSettingsStatusItems } from '../statusItem/useMapSettingsStatusItems.hook';
import { useProximityExportStatusItems } from '../statusItem/useProximityExportStatusItems.hook';

const announcements: Announcement[] = [
  {
    colors: {
      backgroundColor: '#DFE4E7',
      color: '#111B22',
    },
    id: -1,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa" role="img" aria-hidden="true" style="color:currentColor"><!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z" fill="currentColor"></path></svg>\n',
    subject: 'Matej test announcement',
    titleFontSize: 18,
    messageFontSize: 14,
    message: '<p>some content 8 font size</p>',
  },
  {
    colors: {
      backgroundColor: '#C7E7FF',
      color: '#0078CE',
    },
    id: -2,
    icon: null,
    subject: 'Test',
    titleFontSize: 16,
    messageFontSize: 14,
    message: '<p>Test Test</p>',
  },
  {
    colors: {
      backgroundColor: '#FFE0C7',
      color: '#E76900',
    },
    id: -3,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa" role="img" aria-hidden="true" style="color:currentColor"><!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M272 288h-64C163.8 288 128 323.8 128 368C128 376.8 135.2 384 144 384h192c8.836 0 16-7.164 16-16C352 323.8 316.2 288 272 288zM240 256c35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64S204.7 256 240 256zM496 320H480v96h16c8.836 0 16-7.164 16-16v-64C512 327.2 504.8 320 496 320zM496 64H480v96h16C504.8 160 512 152.8 512 144v-64C512 71.16 504.8 64 496 64zM496 192H480v96h16C504.8 288 512 280.8 512 272v-64C512 199.2 504.8 192 496 192zM384 0H96C60.65 0 32 28.65 32 64v384c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64V64C448 28.65 419.3 0 384 0zM400 448c0 8.836-7.164 16-16 16H96c-8.836 0-16-7.164-16-16V64c0-8.838 7.164-16 16-16h288c8.836 0 16 7.162 16 16V448z" fill="currentColor"></path></svg>\n',
    subject: 'Testing color picker',
    titleFontSize: 24,
    messageFontSize: 12,
    message: '<p>Test updated color picker for overrides</p>',
  },
  {
    id: -4,
    subject: 'Test announcement with button',
    titleFontSize: 16,
    message: '<p>This announcement has long text and a button. <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et felis a nulla interdum luctus. Nulla maximus mi metus, et consequat tellus aliquet dignissim. Etiam ac viverra orci. Ut lobortis, ipsum non facilisis feugiat, dui enim gravida orci, commodo sodales nisl dui id erat. Nullam ac hendrerit tellus, in iaculis ex. Cras sit amet gravida mauris, a tincidunt dui. Nullam tristique varius viverra. Curabitur hendrerit nisi sit amet leo luctus auctor. Vivamus sodales euismod orci eu molestie.</span></p>',
    messageFontSize: 14,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa" role="img" aria-hidden="true" style="color:currentColor"><!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z" fill="currentColor"></path></svg>\n',
    colors: {
      backgroundColor: '#FFE0C7',
      color: '#E76900',
    },
    button: {
      title: 'I\'m a button',
      link: 'www.google.com',
      style: ButtonStyle.Success,
    },
  },
];

export const useTopUnderbarSampleItems = ({ generateSamples, isMobileScreen }: {generateSamples: boolean; isMobileScreen?: boolean}) => {
  const mapSettingsStatusItems = useMapSettingsStatusItems({ generateSamples });
  const exportImageStatusItems = useExportImageStatusItems({ generateSamples });
  const proximityExportStatusItems = useProximityExportStatusItems({ generateSamples });
  const fileExportStatusItems = useFileExportStatusItems({ generateSamples });
  const [t] = useTranslation();

  return useMemo(() => {
    if (!generateSamples) {
      return [];
    }

    return [
      ...mapSettingsStatusItems,
      ...exportImageStatusItems,
      ...proximityExportStatusItems,
      ...fileExportStatusItems,
      renderGeocodingState({
        state: {
          inProgress: true,
          isRequired: true,
          paused: { isPaused: false, changeRequestSent: false },
          progress: 50,
          triggeredByUserId: null,
        },
        togglePause: noop, t, isMobileVersion: isMobileScreen,
      }),
      renderBoundaryWMSOptimizedTerritoryItem({
        item: {
          type: 'WMS',
          isFailed: false,
          id: -1,
          status: BoundaryCreateWMSOptimizedStatus.RebalancingTerritories,
          startedOnCurrentTab: false,
        }, t, isMobileVersion: isMobileScreen, onCancel: noop,
      }),
      renderSearchEntries({
        items: [{
          id: 'XXX',
          text: 'Atlanta',
          columnId: '1',
          columnName: 'City',
        }, {
          id: 'YYY',
          text: 'Occupied',
          columnId: '2',
          columnName: 'Status',
        }], removeSearchItem: noop, removeAllSearchItems: noop,
      }),
      renderConfirmation({
        icon: faMap,
        id: 'sample-confirmation',
        text: 'This is a sample confirmation question. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.',
        onConfirm: noop,
        onDeny: noop,
      }),
      ...announcements.map(announcement => renderAnnouncement({ announcement, markAnnouncementAsSeen: noop, isMobileVersion: isMobileScreen })),
    ];
  }, [exportImageStatusItems, generateSamples, isMobileScreen, mapSettingsStatusItems, proximityExportStatusItems, fileExportStatusItems, t]);
};
